import React, { useState, useRef, useEffect } from "react"
import { FaQrcode } from "react-icons/fa"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, } from "components"
import { createPrintRequest } from "utils"
import classes from "./KtPrintQrButton.module.scss"

const KtPrintQrButton = props => {
  const { tableName } = props

  const [t, i18n] = useTranslation()

  const printers = useSelector(state => state.printers)

  const systemSettings = useSelector(state => state.systemSettings)

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handlePrintQrCode = async () => {
    const printerSettings =
      printers.find(printer => printer.forQrTable)

    if (!printerSettings) return

    setLoading(true)

    const {
      domain,
      subdomain,
      serviceTypeName,
      qrCodeExpiryTime
    } = systemSettings

    const printData = {
      domain,
      subdomain,
      qrCodeExpiryTime,
      serviceTypeName,
      tableName
    }

    const request = {
      printData,
      printType: "tableQrCode",
      printerSettings
    }

    try {
      await createPrintRequest(request)
    } catch (err) {
      console.log(err)
    }

    if (unmount.current) return

    setLoading(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Button
      className={classes["button"]}
      loading={loading}
      color="info"
      onClick={handlePrintQrCode}
    >
      <FaQrcode
        size={15}
        color="white"
        className={classes["icon"]}
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("پرینت_QR")}
      </span>
    </Button>
  )
}

export default KtPrintQrButton